import PdfGenerator from "../pdf-generator";
import { applyCpfMaskIfNeeded } from "@/utils/cpf-mask";

export const NEW_RESPONSIBLE_CPF_LABEL = "CPF do Novo Responsável:";

interface ReportGeneratorProps {
  storeCode: string;
  previousBalance: string;
  entries: string;
  exits: string;
  dailyClosing: string;
  dailyBalance: string;
  createdAt: Date;
  treasuryName?: string;
  newResponsibleCpf?: string | null;
}

const ReportGenerator = ({
  storeCode,
  previousBalance,
  entries,
  exits,
  dailyClosing,
  dailyBalance,
  createdAt,
  treasuryName,
  newResponsibleCpf,
}: ReportGeneratorProps) => {

  const generatePdf = PdfGenerator({
    fileName: "relatorio_saldo",
    bodyContent: (doc) => {
      const pageWidth = doc.internal.pageSize.width;
      const tableStartY = 50;
      const cellPadding = 5;
      const columnX1 = 30;
      const columnX2 = pageWidth - 90;

      doc.setFont("Helvetica", "bold");
      doc.setFontSize(18);
      doc.text("Relatório de Saldo", pageWidth / 2, 40, { align: "center" });

      doc.setFontSize(12);
      doc.setFillColor(230, 230, 230);
      doc.rect(columnX1 - cellPadding, tableStartY, pageWidth - 60, 10, "F");
      doc.text("Informação", columnX1, tableStartY + 7);
      doc.text("Valor", columnX2, tableStartY + 7);

      const rowHeight = 10;
      const data = [
        { label: "Loja", value: `${storeCode}` },
        { label: "Saldo Anterior", value: `R$ ${previousBalance}` },
        { label: "Entradas", value: `R$ ${entries}` },
        { label: "Saídas", value: `R$ ${exits}` },
        { label: "Fechamento do Dia", value: `R$ ${dailyClosing}` },
        { label: "Saldo do Dia", value: `R$ ${dailyBalance}` },
        { label: "Criado em", value: createdAt.toLocaleString("pt-BR") },
      ];

      doc.setFont("Helvetica", "normal");
      data.forEach((item, index) => {
        const rowY = tableStartY + (index + 1) * rowHeight;
        doc.text(item.label, columnX1, rowY + 7);
        doc.text(String(item.value), columnX2, rowY + 7);
      });

      const signatureStartY = tableStartY + data.length * rowHeight + 40;
      const signatureLineWidth = pageWidth - 47;

      doc.setFont("Helvetica", "bold");
      doc.text("RESPONSÁVEL ATUAL", columnX1, signatureStartY);
      doc.setFont("Helvetica", "normal");

      const responsibleY = signatureStartY + 10;
      doc.text(`Nome responsável atual Tesouraria: ${treasuryName || ""}`, columnX1, responsibleY);
      doc.line(
        columnX1 + 69,
        responsibleY,
        columnX1 + signatureLineWidth,
        responsibleY
      );

      const responsibleSignatureY = responsibleY + 10;
      doc.text("Assinatura:", columnX1, responsibleSignatureY);
      doc.line(
        columnX1 + 22,
        responsibleSignatureY,
        columnX1 + 125,
        responsibleSignatureY
      );

      doc.text("Data:____/__/____", columnX1 + 127, responsibleSignatureY);

      const confirmerY = responsibleSignatureY + 20;
      doc.setFont("Helvetica", "bold");
      doc.text("CONFERENTE", columnX1, confirmerY);
      doc.setFont("Helvetica", "normal");

      const confirmerNameY = confirmerY + 10;
      doc.text("Nome novo responsável Tesouraria:", columnX1, confirmerNameY);
      doc.line(
        columnX1 + 69,
        confirmerNameY,
        columnX1 + signatureLineWidth,
        confirmerNameY
      );

      const confirmerCpfY = confirmerNameY + 10;
      if (newResponsibleCpf) {
        doc.text(
          `${NEW_RESPONSIBLE_CPF_LABEL} ${applyCpfMaskIfNeeded(newResponsibleCpf)}`,
          columnX1,
          confirmerCpfY
        );
      }

      const confirmerSignatureY = newResponsibleCpf
        ? confirmerCpfY + 10
        : confirmerNameY + 10;
      doc.text("Assinatura:", columnX1, confirmerSignatureY);
      doc.line(
        columnX1 + 22,
        confirmerSignatureY,
        columnX1 + 125,
        confirmerSignatureY
      );

      doc.text("Data: ____/__/____", columnX1 + 127, confirmerSignatureY);
    },
  });

  return generatePdf;
};

export default ReportGenerator;
